/*
  Pokitrio-Redesign (Plan 4 Task 4): <pkt-fbt>, „Wird häufig zusammen gekauft“ (sections/pkt-fbt.liquid).
  * Je Artikel [data-variant-id][data-preis-cent] mit Haekchen .pkt-fbt__wahl (das eigene Produkt: disabled checked).
  * An-/Abwaehlen: Summe (deutsches Format ueber window.pktWarenkorb.preis, Intl de-DE mit normalem Leerzeichen vor €),
    „Gesamt fuer N Artikel“ und Button-Text aus data-text-1/2/3 (fertig uebersetzt, Plural je Sprache).
  * Button: alle gewaehlten Positionen in einem /cart/add.js-Aufruf ueber window.pktWarenkorb.hinzufuegen
    (assets/pkt-card.js, dieselbe Event-Folge wie Impacts product-form: Zaehler und Drawer aktualisieren sich, der
    Drawer oeffnet sich). aria-busy setzt und loest die Hilfe; der Button wird nie gesperrt.
  * Fehler (z. B. 422 ausverkauft oder Mengenlimit): Text in .pkt-fbt__meldung direkt am Button (role=status,
    aria-live=polite), Shopify-Text plus Hinweis aus data-fehler. Sie bleibt bis zur naechsten Wahl bzw. zum
    naechsten Klick stehen. Nichts geht still verloren.
  * variant:change aus dem Kaufbereich (Formular product-form-<produkt-id>-…): Das eigene Produkt uebernimmt Variante
    und Preis. Ist die neue Variante nicht kaufbar, verschwindet der Kasten, bis wieder eine kaufbare gewaehlt ist.
*/
(() => {
  if (window.customElements.get('pkt-fbt')) return;

  class PktFbt extends HTMLElement {
    connectedCallback() {
      this._artikel = Array.from(this.querySelectorAll('[data-variant-id]'));
      this._knopf = this.querySelector('.pkt-fbt__btn');
      this._meldung = this.querySelector('.pkt-fbt__meldung');
      if (!this._knopf || !this._meldung) return;

      this._onWahl = (e) => {
        if (!e.target.matches('.pkt-fbt__wahl')) return;
        this._melden('');
        this._aktualisieren();
      };
      this._onKlick = () => this._hinzufuegen();
      this._onVariante = (e) => this._varianteGewechselt(e.target, e.detail || {});
      this.addEventListener('change', this._onWahl);
      this._knopf.addEventListener('click', this._onKlick);
      document.addEventListener('variant:change', this._onVariante);
      // Startzustand aus den echten Haken: Browser (Firefox) stellen Checkboxen nach dem Neuladen wieder her
      this._aktualisieren();
    }

    disconnectedCallback() {
      if (!this._onWahl) return;
      this.removeEventListener('change', this._onWahl);
      this._knopf.removeEventListener('click', this._onKlick);
      document.removeEventListener('variant:change', this._onVariante);
    }

    _gewaehlt() {
      return this._artikel.filter((a) => a.querySelector('.pkt-fbt__wahl').checked);
    }

    _aktualisieren() {
      if (!window.pktWarenkorb) return;
      const gewaehlt = this._gewaehlt();
      const n = gewaehlt.length;
      const summe = gewaehlt.reduce((s, a) => s + Number(a.dataset.preisCent), 0);
      this.querySelector('.pkt-fbt__summe').textContent = window.pktWarenkorb.preis(summe);
      ['.pkt-fbt__anzahl', '.pkt-fbt__btn-text'].forEach((sel) => {
        const feld = this.querySelector(sel);
        // data-text-1 heisst im dataset „text-1“ (vor Ziffern kein camelCase): darum getAttribute
        const text = feld && feld.getAttribute(`data-text-${n}`);
        if (text) feld.textContent = text;
      });
    }

    async _hinzufuegen() {
      const positionen = this._gewaehlt().map((a) => ({ id: Number(a.dataset.variantId), quantity: 1 }));
      if (!positionen.length) return;
      this._melden('');
      const ergebnis = window.pktWarenkorb
        ? await window.pktWarenkorb.hinzufuegen(positionen, this._knopf)
        : { ok: false };
      if (!ergebnis.ok && !ergebnis.belegt) this._melden([ergebnis.shop ? ergebnis.fehler : '', this.dataset.fehler].filter(Boolean).join(' '));
    }

    _melden(text) {
      this._meldung.textContent = '';
      if (!text) return;
      // Leeren und im naechsten Bild setzen: Screenreader lesen auch eine gleichlautende zweite Meldung vor.
      // Die Meldung bleibt stehen, bis der Kunde wieder waehlt oder klickt.
      window.requestAnimationFrame(() => { this._meldung.textContent = text; });
    }

    _varianteGewechselt(formular, detail) {
      const v = detail.variant;
      // Formular-ID per getAttribute: form.id (und Impacts detail.formId) liefert das Feld <input name="id">
      const formId = formular && formular.getAttribute ? formular.getAttribute('id') || '' : '';
      if (!v || !formId.startsWith(`product-form-${this.dataset.produktId}-`)) return;
      const eigenes = this._artikel.find((a) => a.hasAttribute('data-eigenes'));
      if (!eigenes) return;
      const kaufbar = !!v.available && v.price > 0 && !v.requires_selling_plan;
      this.hidden = !kaufbar;
      if (!kaufbar) return;
      eigenes.dataset.variantId = String(v.id);
      eigenes.dataset.preisCent = String(v.price);
      const preisFeld = eigenes.querySelector('.pkt-fbt__preis');
      if (preisFeld && window.pktWarenkorb) preisFeld.textContent = window.pktWarenkorb.preis(v.price);
      this._aktualisieren();
    }
  }

  window.customElements.define('pkt-fbt', PktFbt);
})();
